import React from 'react';
import './Team.css';

const Team = () => {
  const leaders = [
    {
      id: 1,
      name: 'Vantala Jangaiah Yadav',
      role: 'Founder & Visionary',
      position: 'left',
      bio: 'The visionary behind Swayam Homes, Vantala Jangaiah Yadav transformed a humble beginning into a thriving real estate powerhouse. With over a decade of industry expertise, his unwavering commitment to customer satisfaction and business excellence has shaped the company\'s DNA. His leadership philosophy centers on trust, resilience, and creating lasting value for every stakeholder.',
      icon: '👔'
    },
    {
      id: 2,
      name: 'Vantala Nishith Yadav',
      role: 'Project Head',
      position: 'center',
      bio: 'Bringing a new generation of energy and innovation to project execution, Vantala Nishith Yadav represents the future of Swayam Homes. As Project Head, he combines modern project management expertise with the foundational values inherited from the company\'s legacy. His focus on quality, timely delivery, and operational excellence drives the success of every development.',
      icon: '🏗️'
    },
    {
      id: 3,
      name: 'Sripal Reddy Kattula',
      role: 'Marketing Head',
      position: 'right',
      bio: 'With 15 enriching years at Swayam Homes, Sripal Reddy Kattula has been instrumental in shaping the company\'s market presence and brand narrative. His strategic expertise spans all major projects and market initiatives. His deep understanding of customer needs and market dynamics has consistently driven growth and established Swayam Homes as a trusted name in the real estate industry.',
      icon: '📈'
    }
  ];

  return (
    <section className="team">
      {/* Eyebrow */}
      <div className="team-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Leadership</span>
        <div className="eyebrow-line"></div>
      </div>

      {/* Main Heading */}
      <h1 className="team-title">
        Meet Our <em>Leadership</em>
      </h1>

      {/* Subtitle */}
      <p className="team-subtitle">
        Driven by vision, experience, and an unwavering commitment to excellence
      </p>

      {/* Team Grid */}
      <div className="team-grid">
        {leaders.map((leader, index) => (
          <div 
            key={leader.id} 
            className={`team-card ${leader.position}`}
            style={{ animationDelay: `${0.5 + index * 0.15}s` }}
          >
            <div className="team-card-content">
              {/* Icon/Avatar Area */}
              <div className="team-avatar">
                <div className="avatar-placeholder">
                  {leader.icon}
                </div>
              </div>

              {/* Name & Role */}
              <h3 className="team-name">{leader.name}</h3>
              <p className="team-role">{leader.role}</p>

              {/* Bio */}
              <p className="team-bio">{leader.bio}</p>

              {/* Timeline Indicator */}
              {leader.role === 'Founder & Visionary' && (
                <div className="tenure-badge">
                  <span className="tenure-icon">⭐</span>
                  Visionary Leader
                </div>
              )}
              {leader.role === 'Project Head' && (
                <div className="tenure-badge next-gen">
                  <span className="tenure-icon">🚀</span>
                  Next Generation
                </div>
              )}
              {leader.role === 'Marketing Head' && (
                <div className="tenure-badge experience">
                  <span className="tenure-icon">📊</span>
                  15 Years Experience
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Team Values */}
      <div className="team-values">
        <h2>What Unites Our Team</h2>
        <div className="values-grid">
          <div className="value-item">
            <div className="value-icon">🎯</div>
            <h4>Shared Vision</h4>
            <p>United by a common mission to deliver exceptional real estate solutions and lasting customer value.</p>
          </div>

          <div className="value-item">
            <div className="value-icon">🤝</div>
            <h4>Collaborative Spirit</h4>
            <p>Working as one cohesive unit where founder wisdom meets next-generation innovation.</p>
          </div>

          <div className="value-item">
            <div className="value-icon">💪</div>
            <h4>Excellence</h4>
            <p>Committed to maintaining the highest standards in every project, every interaction, every outcome.</p>
          </div>

          <div className="value-item">
            <div className="value-icon">🏆</div>
            <h4>Legacy Building</h4>
            <p>Creating lasting impact through trusted relationships and transformative real estate development.</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="team-cta">
        <h2>Ready to Experience Swayam Excellence?</h2>
        <p>Connect with our team and discover how decades of expertise and modern innovation can help you find your perfect home.</p>
        <button className="cta-button">Contact Our Team</button>
      </div>
    </section>
  );
};

export default Team;
